import _ from 'lodash';
import AppConstatnt from '../../../../config/app.constants';

class RoutesController {
  /*@ngInject*/
  constructor(Auth, $state, User, Navigation, RouteService, $translate, LocationService, ScanService, $window, $q, Modal,
    ShipmentService, BranchService, DateUtil, SetupService, DataCounter, $filter, UsersService, TimezoneList, CommonLayoutService, $rootScope, FetchReactData) {
    this.FetchReactData = FetchReactData;
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.BranchService = BranchService;
    this.ScanService = ScanService;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.showData = false;
    this.DateUtil = DateUtil;
    this.SetupService = SetupService;
    this.DataCounter = DataCounter;
    this.Navigation = Navigation;
    this.$filter = $filter;
    this.UsersService = UsersService;
    this.TimezoneList = TimezoneList;
    this.$window = $window;
    this.CommonLayoutService = CommonLayoutService;
    this.$rootScope = $rootScope;

    this.model = {
      route: null,
      branch: User.getUser().branchId,
      type: '',
      max: 200,
      deliveries: [],
      pickups: [],
      date: '',
      routeStatsObj: {
        routeDetails: {}
      },
      pickupShipmentStats: {
        pickupAmount: '$',
        pickupCount: '#'
      },
      selectedPickupShipmentStats: '$',
      deliveryShipmentStats: {
        deliveryAmount: '$',
        deliveryCount: '#'
      },
      selectedDeliveryShipmentStats: '$',
      timezone: moment.tz.guess(),
      buckets: [],
      timezoneList: this.TimezoneList.getTimezoneList(),
      loggedInUser: User.getUser().id
    };

    this.routes = [];
    this.allRoutes = [];
    this.branches = [];
    this.locationEvent = [];
    this.shipmentEvent = [];
    this.locationData = '';

    this.days = [
      { label: this.$translate.instant('location.sun'), value: 'Sun' },
      { label: this.$translate.instant('location.mon'), value: 'Mon' },
      { label: this.$translate.instant('location.tues'), value: 'Tue' },
      { label: this.$translate.instant('location.wed'), value: 'Wed' },
      { label: this.$translate.instant('location.thurs'), value: 'Thu' },
      { label: this.$translate.instant('location.fri'), value: 'Fri' },
      { label: this.$translate.instant('location.sat'), value: 'Sat' },
      { label: this.$translate.instant('location.hol'), value: 'Hol' }
    ];
  }

  loadPermission() {
    this.acl = {};
    this.hasACL = {};

    [].forEach((permissionKey) => {
      this.acl[permissionKey] = this.User.getACL(permissionKey)

      this.hasACL[permissionKey] = {};

      this.acl[permissionKey].forEach((permission) => {
        this.hasACL[permissionKey][permission] = true;
      });
    });
  }

  tabSelection(selectedValue) {
    if (selectedValue == 'Sum') {

    } else if (selectedValue == 'All') {

    }
    this.model.type = selectedValue;
  }

  $onInit() {
    this.locationData = this.FetchReactData.getTransitionData() || this.DataCounter.getData();

    let routeData = localStorage.getItem('DataCounter');
    if(routeData){
      const data = JSON.parse(routeData);
      this.DataCounter.setData(data);
      localStorage.removeItem('DataCounter');
    }
    // const transitionData = this.FetchReactData.getTransitionData();
    // if (transitionData) {
    //   this.DataCounter.setData(transitionData);
    //   this.FetchReactData.clearTransitionData();
    // }
    // this.model.type = "Sum";
    this.loadPermission();
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/routes');

    this.$q.all([
      // this.BranchService.all(null, 0, 1000),
      this.SetupService.get(this.User.getUser().branchId),
      this.UsersService.getUserFieldData(this.model.loggedInUser)
    ])
      .then((data) => {
        const date = this.DateUtil.convertToDate(data[0].currentVaultDate);
        this.model.date = date;
        this.model.userdetails = data[1];
        this.model.timezone = this.model.userdetails.timezone ? this.model.userdetails.timezone : moment.tz.guess();
        // this.branches = data[0].results;
      })
      .then(() => {
        // this.getRoutes('', 0)
        this.loadRoutes()
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // getRoutes(searchKey, offset) {
  //   searchKey = searchKey || '';
  //   const routeSearchObj = {
  //     queryJSON: {
  //       rules: [
  //         {
  //           field: 'branchId',
  //           condition: '=',
  //           data: this.User.getUser().branchId
  //         },
  //         {
  //           group: {
  //             rules: [{
  //               field: 'id',
  //               condition: 'like',
  //               data: '%' + searchKey + '%'
  //             },
  //             {
  //               field: 'name',
  //               condition: 'like',
  //               data: '%' + searchKey + '%'
  //             }
  //             ],
  //             operator: 'OR'
  //           }
  //         }
  //       ],
  //       operator: 'AND'
  //     }
  //   };

  //   return this.RouteService.all(routeSearchObj, offset, AppConstatnt.defaultPageLimit)
  //     .then((data) => {
  //       if (offset === 0 || offset == undefined) {
  //         this.totalRoutes = data.total;
  //         this.routes = this.mapData(data.results);
  //       } else {
  //         const routes = this.mapData(data.results);
  //         this.routes = this.routes.concat(routes);
  //       }
  //     })
  // }

  resetData() {
    this.totalRoutes = "";
    this.model.route = "";
    this.routes = [];
    this.currentRouteStatus = "";
    this.locationEvent = [];
    this.shipmentEvent = [];
    this.currentRoute = "";
    this.currentTime = "";
    this.showData = false;
  }

  loadRoutes() {
    this.resetData();
    this.loading = true;
    let formattedDate = "";

    if (this.locationData && this.locationData.isRedirected && this.locationData.vaultDate) {
      this.model.date = this.DateUtil.convertToDate(this.locationData.vaultDate);
      formattedDate = moment(this.model.date).format('YYYY-MM-DD')
    }
    else formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    return this.RouteService.getActiveRoutes(this.model.branch, formattedDate)
      .then((res) => {
        const routes = this.mapData(res.results);
        this.totalRoutes = routes.length;
        this.routes = this.routes.concat(routes);
        return res.results;
      })
      .then((routeData) => {
        this.loadData(routeData)
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadData(routeData) {
    if (this.locationData && this.locationData.isRedirected) {
      let route = _.find(routeData, { routeId: this.locationData.routeId })
      if (route) {
        this.model.route = { Key: route.routeName, Value: route.routeId, autoCheckInUpdate: route.autoCheckInUpdate };
        return this.loadRouteData();
      }
      else {
        return this.resetRedirectionData();
      }
    }
  }

  mapData(routes) {
    return routes.map((route) => {
      return {
        Key: route.routeName,
        Value: route.routeId,
        autoCheckInUpdate: route.autoCheckInUpdate
      }
    });
  }

  // load route data base on vaultDate and routeId 
  loadRouteData() {
    if (!this.model.route) {
      return;
    }

    this.loading = true;
    this.currentDate = moment(this.model.date).format('YYYY-MM-DD');
    this.model.buckets = [];
    let shortLoadAmount = 0

    // if (this.model.route && this.model.route.Value) {
    this.RouteService.routeStatus(this.model.route.Value, this.currentDate, this.model.branch)
      .then((data) => {
        this.showData = true;
        // var localTime = moment.utc().toDate();
        // this.currentTime = moment(localTime).format('LT');
        this.model.routeStatsObj.results = data.results;
        this.model.routeStatsObj.delivery = this.model.routeStatsObj.results.delivery;
        this.model.routeStatsObj.pickups = this.model.routeStatsObj.results.pickups;
        this.model.routeStatsObj.routeDetails = this.model.routeStatsObj.results.routeDetails;
        this.model.routeStatsObj.routeStops = this.model.routeStatsObj.results.routeStops;
        this.model.routeStatsObj.buckets = this.model.routeStatsObj.results.buckets;
        const keys = Object.keys(this.model.routeStatsObj.buckets);

        keys.map((key) => {
          this.model.buckets.push({ title: key });
        });

        const shortLoadShipments = this.model.routeStatsObj.buckets['SHORT_LOAD'].results;
        shortLoadShipments.forEach((s, index) => {
          let nextIndex = index + 1;
          if (shortLoadShipments[nextIndex] && s.trackingId === shortLoadShipments[nextIndex].trackingId) {
            shortLoadShipments.splice(nextIndex, 1);
          }
          shortLoadAmount += s.loadedAmount;
        })
        this.model.routeStatsObj.buckets['SHORT_LOAD'].amount = shortLoadAmount;
      })
      .then(() => {
        this.routeStopStacked();
        this.stacked();
        this.deliveryAmountStacked();
        this.generateShipmentsList();
        this.resetRedirectionData();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.loading = false
      })
    // } else {
    // this.loading = false;
    // return false;
    // }
  }

  routeStopStacked() {
    this.routeStopStackData = [];
    const totalRouteStop = this.model.routeStatsObj.routeStops.totalRouteStop;
    const completedRouteStopCount = this.model.routeStatsObj.routeStops.completedRouteStopCount;
    const cantRouteStopCount = this.model.routeStatsObj.routeStops.cantRouteStopCount;
    const noPickupRouteStopCount = this.model.routeStatsObj.routeStops.noPickupRouteStopCount;
    const notWorkedRouteStopCount = this.model.routeStatsObj.routeStops.notWorkedRouteStopCount;
    const totalStopProcessed = this.model.routeStatsObj.routeStops.totalStopProcessed;
    const partialRouteStopCount = this.model.routeStatsObj.routeStops.partialRouteStopCount;
    const madeCRV = this.model.routeStatsObj.routeStops.madeCRV;

    this.routeStopStackData.push({ value: completedRouteStopCount, type: 'success' },{ value: noPickupRouteStopCount, type: 'warning' }, { value: cantRouteStopCount + notWorkedRouteStopCount, type: 'danger' },
      // { value: notWorkedRouteStopCount, type: 'danger' },
      { value: partialRouteStopCount, type: 'warning'}, { value: madeCRV, type: 'warning'});
  };

  // filter route data according to branchId
  branchChanged() {
    this.model.route = null;
    this.showData = false;
    this.getRoutes('', 0);
  }

  routeInfo(routeOf) {
    if (this.model.routeStatsObj.results[routeOf] && this.model.routeStatsObj.results[routeOf].data && this.model.routeStatsObj.results[routeOf].data.length) {
      this.currentDate = moment(this.model.date).format('YYYY-MM-DD');
      this.Modal.deliveryRouteInfo(this.model.routeStatsObj.results[routeOf].data, this.model.route.Value, this.currentDate, routeOf, this.model.timezone, this.model.branch, this.model.routeStatsObj.routeDetails, ({ modal }) => {
        modal.close();
      });
    }
  }

  shipmentsOnHoldInfo(type, info) {
    if (this.model.routeStatsObj.results[type] && this.model.routeStatsObj.results[type][info] && this.model.routeStatsObj.results[type][info].length) {
      this.Modal.deliveryRouteInfo(this.model.routeStatsObj.results[type][info], this.model.route.Value, this.currentDate, info, this.model.timezone, this.model.branch, this.model.routeStatsObj.routeDetails, ({ modal }) => {
        modal.close();
      });
    }
  }

  resetRedirectionData() {
    if (this.locationData) {
      this.locationData.isRedirected = false;
      this.locationData = this.DataCounter.setData();
      this.FetchReactData.clearTransitionData();
    }
  }

  redirectToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

  goToServiceHistory(locationId) {
    const obj = {
      locationId: locationId,
      isRedirected: true
    }
    this.DataCounter.setData(obj);
    this.$state.go('branchManagement.locations');
  }

  goToRouteTab(route) {
    const today = this.model.date.getDay();
    const selectedDay = this.days[today].value;
    this.Navigation.goToSettingsRouteTab(route, selectedDay);
  }

  stacked() {
    this.deliveriesStack = [];
    this.pickupsStack = [];

    var totalDelivered = this.model.routeStatsObj.delivery.delivered;
    var deliveriesOnHold = this.model.routeStatsObj.delivery.deliveriesOnHold;
    var cantDelivered = this.model.routeStatsObj.delivery.cantDelivered;
    var totalPickedUp = this.model.routeStatsObj.pickups.pickedup;
    var pickupsOnHold = this.model.routeStatsObj.pickups.pickupsOnHold;

    this.deliveriesStack.push({ value: totalDelivered, type: 'blue' }, { value: deliveriesOnHold, type: 'warning' }, { value: cantDelivered, type: 'danger' });
    this.pickupsStack.push({ value: totalPickedUp, type: 'blue' }, { value: pickupsOnHold, type: 'warning' });
  };

  translateRouteStatus(status) {
    if (!status || typeof status !== 'string') return;
    else return this.$translate.instant('branch_mgmt.' + status);
  }

  convertToMillisecond(date) {
    var browserTimezone = moment.tz.guess(); // get the browsers current time zone.
    var convertDate = moment.tz(date, browserTimezone).format();  // convert date to specific timezone
    return moment(convertDate).valueOf(); // convert date in milliseconds
  }

  pickupStateSelection(selectedValue) {
    this.model.selectedPickupShipmentStats = this.model.pickupShipmentStats[selectedValue];;
  }

  deliveryStateSelection(selectedValue) {
    this.model.selectedDeliveryShipmentStats = this.model.deliveryShipmentStats[selectedValue];
  }

  getBucketName(status) {
    switch (status) {
      case status:
        return this.$translate.instant('branch_mgmt.routes.bucket_' + status);
      default: return;
    }
  }

  generateShipmentsList() {
    this.model.buckets.forEach((bucket) => {
      if (!this.model.routeStatsObj.buckets[bucket.title].results.length) return;

      let shipmentList = this.model.routeStatsObj.buckets[bucket.title].results;
      let sortByKey = (bucket.title === 'PICKEDUP' || bucket.title === 'PENDING_PICKUP') ? 'fromLocationId' : (bucket.title === 'CANT_STOP' || bucket.title === 'CRV') ? 'locationId' : 'toLocationId';

      shipmentList = _.sortBy(shipmentList, [sortByKey]);
      shipmentList[0].matchPreviousRow = false;

      for (var i = 0; i < shipmentList.length; i++) {
        let locationId = shipmentList[i][sortByKey];
        var cursor = 1;

        for (var j = i + 1; j < shipmentList.length; j++) {
          if (shipmentList[j][sortByKey] === locationId && !shipmentList[j].matchPreviousRow) {
            cursor++;
            shipmentList[j].matchPreviousRow = true;
          }
          else {
            break;
          }
        }
        shipmentList[i].cursor = cursor;
      }
      this.model.routeStatsObj.buckets[bucket.title].results = shipmentList;
    })
  }

  loadImage(type) {
    this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'CARRIER': 'carrier.png',
      'ON_CALL': 'oncall.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }

    let imgURL = this.icon[type]
    return require('../../../../assets/images/' + imgURL);
  }

  getOrderType(shiptype, type) {
    if (shiptype == "C" && type !== null) {
      return this.$translate.instant('atm_residual.order_type_' + type);
    }
    else if (shiptype == "C" && type == null) {
      return shiptype.toUpperCase();
    }
    else {
      return shiptype.toUpperCase();
    }
    // return this.ShipmentService.getOrderType(type);
  }

  ordinalSuffixOf(number) {
    return this.CommonLayoutService.ordinalSuffixOfStopPriority(number);
  }

  goToServiceHistory(locationId) {
    return this.Navigation.goToServiceHistory(locationId, null, true, null);
  }

  goToItemHistory(trackingId) {
    this.$state.go('branchManagement.items', {
      id: trackingId,
    });
  }

  showReceipt(shipments, stats) {
    document.getElementById('shipment-image').blur();
    this.Modal.shipmentImageModal(shipments, shipments.trackingId, stats, ({ modal }) => {
    }, ({ modal }) => {
      modal.close();
    });
  }

  getComments(comment) {
    this.Modal.confirm({
      header: this.$translate.instant('common.comment'),
      message: comment,
      callback: (({
        modal
      }) => {
        modal.close();
      }),
      negative: (({
        modal,
      }) => {
        modal.close();
      }),
      buttons: ['common.close'],
      type: 'success'
    })
  }

  calculateDuration(startDate, endDate) {
    let start = moment(startDate).valueOf();
    let end = moment(endDate).valueOf();

    if (start && end && end < start) { // reverse the date order
      const t = startDate;
      startDate = endDate;
      endDate = t;
    }

    let ms = moment(endDate).diff(startDate);
    let duration = moment.duration(ms);
    return Math.floor(duration.asHours()) + moment.utc(ms).format(":mm:ss");
  }

  deliveryAmountStacked() {
    this.deliveryAmountStack = [];

    const totalDeliveredAmount = this.model.routeStatsObj.delivery.totalDeliveredShipmentAmount;
    const totalNotDeliveredAmount = this.model.routeStatsObj.buckets['NOT_LOADED_OR_NOT_DELIVERED'].amount;
    const totalNotDeliveredShipments = this.model.routeStatsObj.buckets['NOT_LOADED_OR_NOT_DELIVERED'].results.length;
    const totalDeliveredShipments = this.model.routeStatsObj.delivery.delivered;
    const notDeliveredShipments = this.model.routeStatsObj.delivery.notDeliveredShipments.length;
    const notDeliveredShipmentAmount = this.model.routeStatsObj.delivery.notDeliveredShipmentAmount;

    this.deliveryAmountStack.push(
      { value: totalDeliveredShipments, type: 'success', amount: totalDeliveredAmount },
      { value: totalNotDeliveredShipments, type: 'warning', amount: totalNotDeliveredAmount },
      { value: notDeliveredShipments, type: 'danger', amount: notDeliveredShipmentAmount }
    );
  };

  currencyFilter(amount) {
    let fraction = amount % 1 === 0 ? 0 : 2;
    return this.$filter('currency')(amount, '$', fraction);
  }

  stopCommentsModal(obj) {
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');
    this.Modal.stopComments(this.model.route.Value, formattedDate, obj.toLocationId || obj.locationId, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  sendDeliveryPickupReports(sendDeliveryReports, sendPickupReports) {
    const routeId = this.model.route.Value;
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    this.reportsObj = {};
    this.reportsObj[routeId] = { sendDeliveryReports, sendPickupReports };

    this.RouteService.sendDeliveryPickupReports(routeId, formattedDate, this.model.timezone, sendDeliveryReports, sendPickupReports)
      .then(() => {
        const msg = sendDeliveryReports ? this.$translate.instant(`route.delivery_report_msg`, { routeId }) : this.$translate.instant(`route.pickup_report_msg`, { routeId });

        this.Modal.confirm({
          header: this.$translate.instant('successModal.title'),
          message: msg,
          callback: (({
            modal
          }) => {
            modal.close();
          }),
          buttons: ['common.ok'],
          type: 'success'
        })
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.reportsObj[routeId].sendDeliveryReports = false;
        this.reportsObj[routeId].sendPickupReports = false;
      })
  }

  exportAllRouteStops() {
    this.model.exportRouteStops = true;
    const routeId = this.model.route.Value;
    const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

    this.RouteService.exportAllRouteStops(this.model.branch, routeId, formattedDate, this.model.timezone)
      .then(() => { })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.exportRouteStops = false;
      })
  }

  print(title, flag, data) {
    let new_path = this.$state.href('printRoutes');
    window.w = window.open(new_path, '_blank');
    window.w.printData = {
      routeId: this.model.route.Value,
      vaultDate: this.currentDate,
      title, flag, data,
      timezone: this.model.timezone
    }
  }

  redirectToATMCount(item) {
    return this.Navigation.goToAtmCount(item.trackingId, true, null, item.fundingSourceId)
  }

  notDeliveredResolutionModal(trackingId, obj) {
    this.Modal.notDeliveredResolution(trackingId, obj, ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close();
    })
  }

  checkInManifest() {
    const url = this.$state.href('printCheckin', {
      branchId: this.model.branch,
      scannedRouteId: this.model.route.Value,
      date: this.currentDate
    });

    this.$window.open(url, '_blank')
  }

}
export default RoutesController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/routes/routes.controller.js